import { render, staticRenderFns } from "./logoWhite.vue?vue&type=template&id=cd1973a0&"
import script from "./logoWhite.vue?vue&type=script&lang=js&"
export * from "./logoWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports